const isNotEmpty = (value: string | string[] | undefined) => {
    if (typeof value === 'object') {
        throw new Error('Object can not be validated for emptiness');
    }

    // Carefull with JS falsy values like '0' etc
    if (!value) {
        return false;
    }

    if (Array.isArray(value)) {
        return value.length > 0;
    }

    // Must be strings from here on
    return value.trim().length === 0 ? false : true;
};

export default isNotEmpty;
